import * as actionTypes from "../actionTypes";

export const getUser = payload => ({
    type: actionTypes.GET_USER,
    payload
})

export const setUser = payload => ({
    type: actionTypes.SET_USER,
    payload
})

export const createUser = payload => ({
    type: actionTypes.CREATE_USER,
    payload
})

export const updateUser = payload => ({
    type: actionTypes.UPDATE_USER,
    payload
})

export const deleteUser = payload => ({
    type: actionTypes.DELETE_USER,
    payload
})

export const changeUserStatus = payload => ({
    type: actionTypes.CHANGE_USER_STATUS,
    payload
})